import React, { useEffect, useRef } from "react";
import { emptyString } from "../../../constants";

export const ColorPicker = (props) => {
  const { label, value, setvalue, maxLength } = props;

  const inputRef = useRef(null);

  useEffect(() => {
    inputRef.current?.setCustomValidity(emptyString);
  }, [value]);

  return (
    <div className="col-12 row color-picker-container">
      <div className="col-12 col-md-4 col-sm-12 color-bar-container">
        <label htmlFor={label} className="color-label form-label w-100">
          {label}
        </label>
      </div>
      <div className="col-12 col-md-8 col-sm-12 m-0 p-0">
        <div className="color-picker-field">
          <div className="color-pick">
            <input
              type="color"
              id={label}
              name="favcolor"
              value={value}
              onChange={(e) => setvalue(e.target.value)}
            />
          </div>
          <input
            required
            ref={inputRef}
            pattern="^#+([a-fA-F0-9]{6}|[a-fA-F0-9]{3})$"
            type="text"
            className="no-border color-hex border-0 form-control w-100 font-14-px text-secondary"
            value={value}
            maxLength={maxLength}
            onChange={(e) => setvalue(e.target.value)}
            onInvalid={(e) => {
              e.target.setCustomValidity(
                "Please enter a valid hex color value starting with '#'."
              );
            }}
          />
        </div>
      </div>
    </div>
  );
};
